import { App, Checkbox, Form, Input, Modal, Space } from "antd";
import { CloseSquareFilled, SaveFilled } from '@ant-design/icons';
import { useEffect, useState } from "react";
import execute from "hooks/execute";
import { protectedResources } from "config/msalConfig";

export const DataEditor = ({isOpen, dataItem, onDataEditorFinished, onDataEditorCancelled }) => {
    const [form] = Form.useForm();
    const { message } = App.useApp();

    const [modules, setModules] = useState([]);
    const [isSaving, setIsSaving] = useState(false);


    const fetchModules = async () => {
            try {
              execute("GET", `${protectedResources.api.baseEndPoint}/modules`).then((response) => {
                if (response && response.success) {
                  console.log('response', response);
                  setModules(response.data);
                }
              });
            } catch (error) {
              console.error('Error fetching modules:', error);
            }
    };



    const handleDataEditFinished = async (values) => {
        if (isSaving) return;
        setIsSaving(true);
        try {
            console.log("handleDataEditFinished");
            var newData = {...dataItem, ...values};
            console.log(newData);
            const isEditMode = Boolean(dataItem?.Org_ID);

            // Build module assignment map dynamically so newly added modules are included.
            const moduleKeys = modules.map((module) => module.ShortName);
            const modulesAssigned = moduleKeys.reduce((acc, shortName) => {
                acc[shortName] = Boolean(newData[shortName]);
                return acc;
            }, {});

            newData.modulesAssigned = modulesAssigned;
            console.log(modulesAssigned);
            console.log(newData);

            if(isEditMode){
                console.log("edit")
                const response = await execute('PUT',`${protectedResources.api.baseEndPoint}/organizations`, newData );
                if(!response?.success){
                    throw new Error(response?.message || 'Failed to update organization');
                }
                newData = {...newData, ...response.data};
            }
            else{
                console.log("add")
                const response = await execute('POST',`${protectedResources.api.baseEndPoint}/organizations`, newData);
                if(!response?.success){
                    throw new Error(response?.message || 'Failed to add organization');
                }
                newData = {...newData, ...response.data};
            }
            setIsSaving(false);
            message.success(isEditMode ? "Organization updated successfully" : "Organization added successfully");
            onDataEditorFinished(newData);
        } catch (error) {
            console.error('Failed saving organization + plan assignment:', error);
            setIsSaving(false);
            message.error(error?.message || 'Failed to save organization details');
        }
    }

    const handleDataEditCancelled = () => {
        if (isSaving) return;
        console.log("handleDataEditCancelled");
        onDataEditorCancelled();
    }
    
    useEffect(() => {
        // Convert Modules string to an array
        console.log(dataItem)
        if (!isOpen) return;

        const hydrate = async () => {
            form.setFieldsValue({
                organizationName: dataItem?.Org_Name || '',
                address: dataItem?.Org_Address || '',
                adminEmail: dataItem?.Org_Email || '',
            });
        };

        hydrate();
    }, [isOpen, dataItem, form]);

    useEffect(() => {
        if (!isOpen) return;

        const modulesValue = dataItem?.Modules;
        const selectedModules = Array.isArray(modulesValue)
            ? modulesValue
            : (typeof modulesValue === "string" ? modulesValue.split(",").map(module => module.trim()) : []);

        const moduleValues = selectedModules.reduce((acc, module) => {
            acc[module] = true;
            return acc;
        }, {});

        form.setFieldsValue({
            ...moduleValues
        });
    }, [isOpen, dataItem, form])

    useEffect(()=>{
        fetchModules()
    },[])



    return (
        <Modal
            open={isOpen}
            className="h-3"
            title={dataItem ? "Edit Organization" : "Add New Organization"}
            okText={<Space><SaveFilled />Save</Space> }
            cancelText={<Space><CloseSquareFilled />Cancel</Space> }
            confirmLoading={isSaving}
            okButtonProps={{ autoFocus: true, htmlType: 'submit', loading: isSaving }} //form: 'dataEditorForm', key: 'submit'
            cancelButtonProps={{ disabled: isSaving }}
            maskClosable={!isSaving}
            closable={!isSaving}
            keyboard={!isSaving}
            onCancel={handleDataEditCancelled}
            destroyOnClose
            modalRender={(dom) => (
                <Form
                style={{height: "80vh", overflowY: "auto"}}
                  layout="horizontal"
                  form={form}
                  name="dataEditorForm"
                  labelCol={{ span: 8 }}
                  wrapperCol={{ span: 16 }}
                  initialValues={{
                    modifier: 'public',
                  }}
                  disabled={isSaving}
                  clearOnDestroy
                  onFinish={handleDataEditFinished}
                >
                  {dom}
                </Form>
            )}>            
            <Form.Item
                name="organizationName"
                label="Organization Name"
                rules={[{ required: true, message: 'Organization Name is required' }]}>
                <Input />
            </Form.Item>


            <Form.Item
                name="address"
                label="Address"
                rules={[{ required: true, message: 'Address is required' }]}>
                <Input />
            </Form.Item>
            <Form.Item
                name="adminEmail"
                label="Admin User Email"
                rules={[
                    { required: true, message: 'Admin User Email is required' },
                ]}>
                <Input readOnly={dataItem}/>
            </Form.Item>

            <Form.Item
                label="Modules To Assign"
                name="modulesAssigned"
            >
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0px' }}>
            
                {modules.map((module) => (
                     <Form.Item
                     key={module.ShortName}
                     style={{marginBottom: 8, height: "fit-content"}}
                     name={module.ShortName}
                     valuePropName="checked"
                 >
                    <Checkbox>{module.ModuleName}</Checkbox>
                  </Form.Item>
                ))}
                </div>
            </Form.Item>
            
        </Modal>
    );
};


